module.exports = __webpack_public_path__ + "static/media/slider1.918cbb42.png";